import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import config from './RootConfig';
import constants from '../constants';

var $ = require('jquery');
var moment = require('moment');

const divs = [];

export default class SearchResultsPage extends Component {

    constructor(props) {
        super(props);

        this.searchKey = "";
        this.state = { divs: divs };
        this.generateDivs = this.generateDivs.bind(this);

        this.setSearchKey();
        this.generateDivs();
    }

    setSearchKey() {
        var url = window.location.href;
        var urlArr = [];
        urlArr = url.split("=");
        this.searchKey = urlArr[1];
    }

    generateDivs() {

        let moreDivs = [];
	if (window.location.hostname.indexOf(config.NJG) != -1) {
		return;
	}
        $.get(config.API_URL + "api/search?key=" + this.searchKey).done((res) => {
            //console.log(res);
            let moreDivs = [];
            if (res.res.length == 0) {
                moreDivs.push(
                    <div style={{ "paddingBottom": "15px" }} key={'noResult'}>
                        <ul className="allpost-wrapper">
                            <div>
                                <h4>
                                    <span className="tag">沒有搜尋結果</span>
                                </h4>
                            </div>
                        </ul>
                    </div>
                );
            } else {
                for (let i = 0; i < res.res.length; i++) {
                    var searchResult = res.res[i];
                    if (searchResult != undefined) {
                        moreDivs.push(
                            <div style={{ "paddingBottom": "15px" }} key={'searchResult-' + searchResult.title}>
                                <ul className="allpost-wrapper">
                                    <div>
                                        <a href={searchResult.url}>
                                            <h4 style={{ "color": "#324fe1" }}>{searchResult.title}</h4>
                                        </a>
                                        <h6>
                                            <span className="tag">{searchResult.desc}</span>
                                        </h6>
                                    </div>
                                </ul>
                            </div>
                        );
                    }
                }
            }

            //this.setState({ divs: this.state.divs.concat(moreDivs) });
            this.setState({ divs: moreDivs });
        });
    }

    componentWillReceiveProps(nextProps) {
        //console.log('componentWillReceiveProps...');

        this.setSearchKey();
        this.generateDivs();
    }

    componentDidMount() {
        //console.log('componentDidMount...');
        window.scrollTo(0, 0);
	if (window.location.hostname.indexOf(config.NJG) != -1) {
    var cx = 'partner-pub-5700807077542472:1157310798';
    var gcse = document.createElement('script');
    gcse.type = 'text/javascript';
    gcse.async = true;
    gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(gcse, s);
	}

    }
    render() {
        
	let s0, s1, s2;
	if (window.location.hostname.indexOf(config.NJG) != -1) {
	/*s0 = (
		//$('head').append('<script src="https://s.yimg.com/uv/dm/scripts/syndication.js"></script>');
		<script src="https://s.yimg.com/uv/dm/scripts/syndication.js"></script>
	);
	s1 = (
					<div id='gad1'></div>
	);*/
	s2 = (
					<div class='gcse-searchresults-only'></div>
	);
	}
            
        return (
            <div style={{ "marginTop": "50px" }}>
                <div className="col-md-1">
                </div>
                <div className="col-md-10">
                    <div className="themeA-container">
                        <div className="row">
                            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12" style={{ "marginTop": "5px" }}>
                                <div className="general-box" style={{ "minHeight": "500px" }}>
                                    <div style={{ "paddingBottom": "10px" }}>
                                        <div>
                                            <h4 style={{ "paddingLeft": "25px" }}>搜尋: {decodeURI(this.searchKey)}</h4>
                                        </div>
                                    </div>
					<div className="gcse-searchresults-only"></div>
                                    {this.state.divs}
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12" style={{ "marginTop": "5px" }}>
                                {/*
                                <div id="articles-slider" className="general-box" style={{ "height": "180px" }}>

                                </div>
                                <div id="articles-slider" className="general-box" style={{ "height": "180px" }}>

                                </div>
                                */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-1">
                </div>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/containers/ResultsPage.js